import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import React, { useContext, useState } from "react";

const useEditCampaignLocation = () => {
  const { lead } = useContext(LeadPageContext);
  const [editCampaignLocationModal, setEditCampaignLocationModal] =
    useState(false);
  const [campaign, setCampaign] = useState(
    lead?.data?.lead?.campaign?.name
      ? lead?.data?.lead?.campaign?.name
      : "Not set"
  );
  const handleChangeCampaign = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCampaign(e.target.value);
  };

  return {
    campaignLocation: {
      editCampaignLocationModal,
      setEditCampaignLocationModal,
      handleChangeCampaign,
      state: campaign,
      setState: setCampaign,
      value: lead?.data?.lead?.campaign?.name || "",
    },
  };
};

export default useEditCampaignLocation;
